/**
 *  @swagger
 *  definitions:
 *    RegattaCheckParams:
 *      type: object
 *      properties:
 *        RegattaId:
 *          description: ID of the associated Regatta
 *          type: string
 *        Name:
 *          description: Name of the RegattaCheck
 *          type: string
 *
 *  @swagger
 *  definitions:
 *    RegattaCheckCreateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaCheckParams'
 *        - type: object
 *          required:
 *            - RegattaId
 *            - Name
 *
 *  @swagger
 *  definitions:
 *    RegattaCheckQueryParams:
 *      allOf:
 *        - type: object
 *          properties:
 *            id:
 *              description: ID of the RegattaCheck
 *              type: string
 *        - $ref: '#/definitions/RegattaCheckParams'
 *
 *  @swagger
 *  definitions:
 *    RegattaCheckUpdateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaCheckQueryParams'
 *        - type: object
 *          required:
 *            - id
 *
 *  @swagger
 *  definitions:
 *    RegattaCheck:
 *      allOf:
 *        - $ref: '#/definitions/RegattaCheckCreateParams'
 *        - $ref: '#/definitions/RegattaCheckUpdateParams'
 *        - $ref: '#/definitions/Timestamps'
 *
 *  @swagger
 *  components:
 *    schemas:
 *      RegattaCheck:
 *        allOf:
 *          - $ref: '#/definitions/RegattaCheck'
 *          - type: object
 *            properties:
 *              Regatta:
 *                description: Regatta of the RegattaCheck
 *                $ref: '#/components/schemas/Regatta'
 */

// Types
import type {
  $Model,
  $ModelClass,
  $ModelClasses,
} from '.';
import type {
  $Field,
} from '../types';

export type $RelationIds = {
  RegattaId: string;
};

export type $Params = {
  Name: string;
};

export type $CreateParams = $Params & $RelationIds;

export type $UpdateParams = {
  id: string;
} & Partial<$CreateParams>;

export type $UpsertParams = $CreateParams & {
  id?: string;
};

export type $QueryParams = {
  id?: null | string;
} & Partial<$CreateParams>;

export type $Associations = {
  Regatta?: $Model<'Regatta'>;
};

export type $ModelParams = $Associations & $CreateParams & {
  id: string;
};

type $Fields = $Params & {
  id: string;
};

const fields = (
  Sequelize,
): Record<keyof $Fields, $Field> => ({
  id: {
    allowNull: false,
    defaultValue: Sequelize.UUIDV4,
    primaryKey: true,
    type: Sequelize.UUID,
    unique: true,
  },
  Name: {
    allowNull: false,
    type: Sequelize.STRING,
    validate: {
      notEmpty: true,
    },
  },
});

export default ((
  Sequelize,
  stack,
): $ModelClass<'RegattaCheck'> => {
  const RegattaCheck = stack.define(
    'RegattaCheck',
    fields(Sequelize),
    {
      tableName: 'RegattaChecks',
    },
  );

  RegattaCheck.associate = (models: $ModelClasses) => {
    models.RegattaCheck.belongsTo(
      models.Regatta,
      {
        as: 'Regatta',
        foreignKey: 'RegattaId',
      },
    );
  };

  RegattaCheck.addScope(
    'defaultScope',
    {
      order: [['createdAt', 'ASC']],
    },
  );

  return RegattaCheck;
});
